export const offSoundingsCollectionOptions = {
  "product": {
    "styles": {
      "product": {
        "@media (min-width: 601px)": {
          "max-width": "calc(25% - 20px)",
          "margin-left": "20px",
          "margin-bottom": "50px",
          "width": "calc(25% - 20px)"
        },
        "img": {
          "height": "calc(100% - 15px)",
          "position": "absolute",
          "left": "0",
          "right": "0",
          "top": "0"
        },
        "imgWrapper": {
          "padding-top": "calc(75% + 15px)",
          "position": "relative",
          "height": "0"
        }
      },
      "title": {
        "font-family": "Montserrat, sans-serif"
      },
      "button": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold",
        ":hover": {
          "background-color": "#3353be"
        },
        "background-color": "#1e3170",
        ":focus": {
          "background-color": "#3353be"
        },
        "border-radius": "5px"
      },
      "price": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold"
      },
      "compareAt": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold"
      },
      "unitPrice": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold"
      }
    },
    "buttonDestination": "modal",
    "contents": {
      "options": false
    },
    "text": {
      "button": "View product"
    },
    "googleFonts": [
      "Montserrat"
    ]
  },
  "productSet": {
    "styles": {
      "products": {
        "@media (min-width: 601px)": {
          "margin-left": "-20px"
        }
      }
    }
  },
  "modalProduct": {
    "contents": {
      "img": false,
      "imgWithCarousel": true,
      "button": false,
      "buttonWithQuantity": true
    },
    "styles": {
      "product": {
        "@media (min-width: 601px)": {
          "max-width": "100%",
          "margin-left": "0px",
          "margin-bottom": "0px"
        }
      },
      "button": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold",
        ":hover": {
          "background-color": "#3353be"
        },
        "background-color": "#1e3170",
        ":focus": {
          "background-color": "#3353be"
        },
        "border-radius": "5px"
      },
      "title": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold",
        "font-size": "26px",
        "color": "#4c4c4c"
      },
      "price": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold",
        "font-size": "18px",
        "color": "#4c4c4c"
      },
      "compareAt": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold",
        "font-size": "15.299999999999999px",
        "color": "#4c4c4c"
      },
      "unitPrice": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold",
        "font-size": "15.299999999999999px",
        "color": "#4c4c4c"
      },
      "description": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold"
      }
    },
    "googleFonts": [
      "Montserrat"
    ],
    "text": {
      "button": "Add to cart"
    }
  },
  "option": {
    "styles": {
      "label": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold"
      },
      "select": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold"
      }
    },
    "googleFonts": [
      "Montserrat"
    ]
  },
  "cart": {
    "styles": {
      "button": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold",
        ":hover": {
          "background-color": "#3353be"
        },
        "background-color": "#1e3170",
        ":focus": {
          "background-color": "#3353be"
        },
        "border-radius": "5px"
      }
    },
    "text": {
      "total": "Subtotal",
      "button": "Checkout"
    },
    "googleFonts": [
      "Montserrat"
    ]
  },
  "toggle": {
    "styles": {
      "toggle": {
        "font-family": "Montserrat, sans-serif",
        "font-weight": "bold",
        "background-color": "#1e3170",
        ":hover": {
          "background-color": "#3353be"
        },
        ":focus": {
          "background-color": "#3353be"
        }
      }
    },
    "googleFonts": [
      "Montserrat"
    ]
  }
};